import React, { useState, useEffect } from 'react'
import List from './Components/List'
import Create from './Components/Create'
import ExcelFileUploadHandler from '../../UIComponents/ExcelFileUploadHandler';
import { useParams } from 'react-router-dom';
import { postAPI, postAPIForm, getURL } from '../../app/api';
import { store } from '../../app/store';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import { hasPermission, isAdmin } from '../../store/hooks/Permission';

export default function RewardAllotment() {
    const [is_edit, setIsEdit] = useState(false);
    const [edit_id, setEditId] = useState(0);
    const { exam_id } = useParams();
    const store_data = JSON.parse(store());
    const [canView, setCanView] = useState(false);
    const [FormData, setFormData] = useState({
        exam_id: exam_id
    });
    const [Error, setError] = useState([]);
    const [examData, setExamData] = useState({});

    useEffect(() => {
        const checkPermissions = async () => {
            if (isAdmin()) {
                setCanView(true);
            } else {
                const viewAllowed = await hasPermission("REWARDS", "RewardAllotment", "VIEW");
                setCanView(viewAllowed);
            }
        };
        checkPermissions();
        fetchExamData();
    }, []);

    const fetchExamData = async () => {
        const payload = {
            id: exam_id
        }
        const response = await postAPI("/exams/fetchSingle", payload);
        if (response?.status) {
            setExamData(response.data[0] || {});
        }
    }


    const publishRewards = async () => {
        const payload = {
            org_id: store_data?.org_id,
            exam_id: exam_id
        }
        const response = await postAPI("/exams/result/publish", payload);
        if (response?.status) {
            window.location.reload();
            toast.success("Rewards published successfully", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                transition: Slide,
            });
        } else {
            toast.error(response?.message || "Failed to publish rewards", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true, progress: undefined,
                transition: Slide,
            });
        }
    }

    return (
        <>
            {!canView ? (
                <div className="container-xxl flex-grow-1 container-p-y">
                    <div className="alert alert-danger">
                        You do not have permission to view this page.
                    </div>
                </div>
            ) : (
                <div className="container-xxl flex-grow-1 container-p-y">
                    <div className="row">
                        <div className="col-12 col-xl-12 col-sm-12 order-1 order-lg-2 mb-4 mb-lg-0">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => { window.location.href = '/Admin/Setting/Exams'; }}>
                                    Back
                                </button>
                                <p className='text-right mb-0'><small class="fw-bold py-3">Dashboard<span class="text-muted fw-light"> / Reward Allotment</span> </small></p>
                            </div>
                            <div className="card">
                                <div className="card-header d-flex justify-content-between align-items-center">
                                    <h5 className='card-title mb-0'>Reward Allotment</h5>
                                    <div>
                                        {
                                            !examData?.is_result_published ? (
                                                <button type="button" className="btn btn-primary" onClick={publishRewards}>Publish Result</button>
                                            )  : (<></>)
                                        }
                                        {/* <Create BTNLabel={"Add New Reward Allotment"} Header={is_edit ? "Update Reward Allotment" : "Create Reward Allotment"} Subheader="" PopupID="RewardAllotment" is_edit={is_edit} setIsEdit={setIsEdit} edit_id={edit_id} setEditId={setEditId} /> */}
                                    </div>
                                </div>
                                <div className="card-datatable table-responsive">
                                    <List PopupID="RewardAllotment" setIsEdit={setIsEdit} setEditId={setEditId} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

